module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-full-1adc023387d00cda8d6acf7004485b44.svg";